import styled from "styled-components";

const StyledInput = styled.input`
  width: 100%;
  height: 48px;
  border: 1px solid ${props => (props.error ? "#4D0F0F" : "#4d4d4d")};
  background: ${props => (props.error ? "#4D2222" : "#383838")};
  padding: 16px;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  color: ${props => (props.dark ? "#fff" : props.light ? "#484848" : "#fff")};
  outline: none;
  box-shadow: none;
  -webkit-appearance: none;
  border-radius: 0;
  transition: all 0.3s cubic-bezier(0.45, 0.24, 0.66, 0.89);
  position: relative;

  &:focus {
    border: 1px solid
      ${props => (props.dark ? "#ccc" : props.light ? "#0B39B2" : "#ccc")};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-alowed;
  }
`;

export default StyledInput;
